import React, { useEffect, useState } from "react";
import "../css/add-property.css";
import AgentHeader from "../../components/agent-ui/AgentHeader";
import {
  Btn,
  FormInput,
  FormTextArea,
  SelectInput2,
  SuccessComp,
} from "../../utils/utils";
import cloud from "../../assets/cloud.png";
import { AxiosAuthPut, imageToBase64 } from "../../api/api";
import { propCat, propType, propUse, state } from "../../utils/ExportObjects";
import { CloseCircle } from "iconsax-react";
import Loading from "../../components/ui/Loading";
import { useNavigate } from "react-router-dom";

const EditProperty = () => {
  const propData = JSON.parse(localStorage.getItem("property"));
  //   console.log(propData);
  const navigate = useNavigate();
  const url = `agent/properties/${propData?.id}/`;
  const [imagesConvert, setImagesConvert] = useState([]);
  const [images, setImages] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isPageLoading, setIsPageLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [imgErr, setImgErr] = useState("");
  const [data, setData] = useState({
    name: propData?.name || "",
    propertyType: propData?.propertyType || "",
    propertyUse: propData?.propertyUse || "",
    propertyCategory: propData?.propertyCategory || "",
    propertyPrice: propData?.propertyPrice || 0,
    propertyDescription: propData?.propertyDescription || "",
    propertyAddress: propData?.propertyAddress || "",
    area: propData?.area || "",
    city: propData?.city || "",
    state: propData?.state || "",
    propertySize: propData?.propertySize || "",
    yearBuilt: propData?.yearBuilt || 0,
    availableAmmenities: propData?.availableAmmenities || "",
    longitude: propData?.longitude || 0,
    latitude: propData?.latitude || 0,
    bathrooms: propData?.bathrooms || 0,
    bedrooms: propData?.bedrooms || 0,
    pictures: [],
  });
  const [dataErr, setDataErr] = useState({
    name: "",
    propertyType: "",
    propertyUse: "",
    propertyCategory: "",
    propertyPrice: "",
    propertyDescription: "",
    propertyAddress: "",
    area: "",
    city: "",
    state: "",
    propertySize: "",
    yearBuilt: "",
    availableAmmenities: "",
    longitude: "",
    latitude: "",
    bathrooms: "",
    bedrooms: "",
    pictures: "",
  });

  const dataChange = (e) => {
    const newData = { ...data };
    newData[e.target.id] = e.target.value;
    setData(newData);
    const newDataErr = { ...dataErr };
    newDataErr[e.target.id] = "";
    setDataErr(newDataErr);
  };

  const handleFileChange = (event) => {
    setImgErr("");
    const files = Array.from(event.target.files);

    if (files.length + images.length > 5 - imagesConvert?.length) {
      setImgErr(`You can only upload up to 5 images. and you have ${imagesConvert?.length} pictures already. Delete some to upload more`);
      return;
    }
    const convertToBase64 = (file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    };

    const processFiles = async () => {
      const newImages = await Promise.all(
        files.map(async (file) => ({
          file,
          base64: await convertToBase64(file),
        }))
      );
      setImages((prevImages) => [...prevImages, ...newImages]);
      setData({ ...data, pictures: newImages.map((img) => img.base64) });
    };

    processFiles();
  };
  const options = state;

  const propTypeArr = propType;
  const propUseArr = propUse;
  const propCatArr = propCat;

  const selectPropType = (value) => {
    setData({
      ...data,
      propertyType: value,
    });
  };
  const selectPropUse = (value) => {
    setData({
      ...data,
      propertyUse: value,
    });
  };
  const selectPropCat = (value) => {
    setData({
      ...data,
      propertyCategory: value,
    });
  };
  const selectPropState = (value) => {
    setData({
      ...data,
      state: value,
    });
  };

  async function convertImages() {
    setIsPageLoading(true);
    const newImage = await Promise.all(
      propData?.images.map(async (item) => {
        return await imageToBase64(item.link);
      })
    );
    setImagesConvert(newImage);
    setIsPageLoading(false);
  }

  useEffect(() => {
    convertImages();
    // eslint-disable-next-line
  }, []);

  const dataObj = {
    name: data?.name,
    propertyType: data?.propertyType,
    propertyUse: data?.propertyUse,
    propertyCategory: data?.propertyCategory,
    propertyPrice: data?.propertyPrice,
    propertyDescription: data?.propertyDescription,
    propertyAddress: data?.propertyAddress,
    area: data?.area,
    city: data?.city,
    state: data?.state,
    propertySize: data?.propertySize,
    yearBuilt: data?.yearBuilt,
    availableAmmenities: data?.availableAmmenities,
    longitude: data?.longitude,
    latitude: data?.latitude,
    bathrooms: data?.bathrooms,
    bedrooms: data?.bedrooms,
    pictures: data?.pictures?.concat(imagesConvert),
  };

  const deletePicture = (img) => {
    if (imagesConvert?.length !== 0) {
      setImagesConvert(imagesConvert.filter((item) => item !== img));
    }
  };

  const addProp = () => {
    setIsLoading(true);
    AxiosAuthPut(url, dataObj)
      .then((res) => {
        // console.log(res);
        setSuccessMsg(res.message);
        setData({
          name: "",
          propertyType: "",
          propertyUse: "",
          propertyCategory: "",
          propertyPrice: 0,
          propertyDescription: "",
          propertyAddress: "",
          area: "",
          city: "",
          state: "",
          propertySize: "",
          yearBuilt: 0,
          availableAmmenities: "",
          longitude: 0,
          latitude: 0,
          bathrooms: 0,
          bedrooms: 0,
          pictures: [],
        });
        setTimeout(() => {
          setSuccessMsg("");
          navigate("/agent/overview");
        }, 2000);
        setIsLoading(false);
      })
      .catch((err) => {
        // console.log(err.response);
        for (let i = 0; i < err?.response?.data?.errors?.length; i++) {
          const fieldName = err?.response?.data?.errors[i].fieldName;
          const error = err?.response?.data?.errors[i].error;
          setDataErr((prevErrs) => ({
            ...prevErrs,
            [fieldName]: error,
          }));
        }
        // setIsLoading(false);
      });
  };

  return (
    <>
      <SuccessComp message={successMsg} />
      <AgentHeader
        header={`Edit Property`}
        // placeholder={"Search for Property"}
      />
      {isPageLoading && <Loading />}
      {!isPageLoading && <div className="property">
        <div className="property-info prop-form_cont">
          <h3>Property Information</h3>
          <div className="prop-form">
            <FormInput
              label={"Property Name"}
              id={"name"}
              value={data.name}
              changeInput={dataChange}
              err={dataErr.name}
            />
            <div className="prop-form_flex">
              <SelectInput2
                label={"Property Type"}
                options={propTypeArr}
                onChange={selectPropType}
                id={"propertyType"}
                err={dataErr.propertyType}
              />
              <SelectInput2
                label={"Property Use"}
                options={propUseArr}
                onChange={selectPropUse}
                err={dataErr.propertyUse}
              />
              <SelectInput2
                label={"Property Category"}
                options={propCatArr}
                onChange={selectPropCat}
                err={dataErr.propertyCategory}
              />
            </div>
            <FormInput
              label={"Property Price"}
              id={"propertyPrice"}
              value={data.propertyPrice}
              changeInput={dataChange}
              err={dataErr.propertyPrice}
            />
            <FormInput
              label={"No of bedrooms"}
              id={"bedrooms"}
              value={data.bedrooms}
              changeInput={dataChange}
              err={dataErr.bedrooms}
            />
            <FormInput
              label={"No of bathrooms"}
              id={"bathrooms"}
              value={data.bathrooms}
              changeInput={dataChange}
              err={dataErr.bathrooms}
            />
          </div>
        </div>
        <div className="property-details prop-form_cont">
          <h3>Property Details</h3>
          <div className="prop-form">
            <FormTextArea
              label={"Property Description"}
              id={"propertyDescription"}
              value={data.propertyDescription}
              changeInput={dataChange}
              err={dataErr.propertyDescription}
            />
            <FormInput
              label={"Property Address"}
              id={"propertyAddress"}
              value={data.propertyAddress}
              changeInput={dataChange}
              err={dataErr.propertyAddress}
            />
            <div className="prop-form_flex">
              <FormInput
                label={"Area"}
                id={"area"}
                value={data.area}
                changeInput={dataChange}
                err={dataErr.area}
              />
              <FormInput
                label={"City/LGA"}
                id={"city"}
                value={data.city}
                changeInput={dataChange}
                err={dataErr.city}
              />
              <SelectInput2
                label={"State"}
                options={options}
                onChange={selectPropState}
                err={dataErr.state}
              />
            </div>
          </div>
        </div>
        <div className="amenities prop-form_cont">
          <h3>Amenities</h3>
          <div className="prop-form">
            <div className="prop-form_flex">
              <FormInput
                label={"Property size"}
                id={"propertySize"}
                value={data.propertySize}
                changeInput={dataChange}
                err={dataErr.propertySize}
              />
              <FormInput
                label={"Year Built"}
                id={"yearBuilt"}
                value={data.yearBuilt}
                changeInput={dataChange}
                err={dataErr.yearBuilt}
              />
            </div>
            <FormInput
              label={"List Available Amenities"}
              id={"availableAmmenities"}
              value={data.availableAmmenities}
              changeInput={dataChange}
              err={dataErr.availableAmmenities}
            />
          </div>
        </div>
        <div className="images prop-form_cont">
          <h3>Images</h3>
          <label htmlFor="picture" className="prop-form img-upload">
            <input
              type="file"
              name="picture"
              id="picture"
              style={{ display: "none" }}
              multiple
              accept=".png, .jpg, .gif, .svg"
              onChange={handleFileChange}
            />
            <img src={cloud} alt="upload" />
            <p>
              <span>Click to upload</span> <br />
              SVG, PNG, JPG or GIF (max. 800x400px) <br />
              Upload max. {5 - imagesConvert?.length} in total
            </p>
            <div
              style={{
                display: "flex",
                gap: "10px",
                marginTop: "10px",
                flexWrap: "wrap",
                justifyContent: "center",
              }}
            >
              {images?.map((img, index) => (
                <img
                  key={index}
                  src={img?.base64}
                  alt="preview"
                  width="100"
                  height="100"
                  style={{ objectFit: "cover", borderRadius: "5px" }}
                />
              ))}
            </div>
          </label>
        </div>
          {dataErr?.pictures && <p style={{color: "red"}}>{dataErr?.pictures}</p>}
          {imgErr && <p style={{color: "red", fontFamily: "Work Sans", textAlign: "center"}}>{imgErr}</p>}
        <div
          style={{
            display: "flex",
            gap: "10px",
            marginTop: "10px",
            flexWrap: "wrap",
            justifyContent: "center",
          }}
        >
          {imagesConvert?.map((img, index) => (
            <div key={index} className="uploaded-img" style={{ position: "relative" }}>
              <img
                src={img}
                alt="preview"
                width="100"
                height="100"
                style={{ objectFit: "cover", borderRadius: "5px" }}
              />
              <CloseCircle
                size={24}
                color="#737475"
                style={{
                  position: "absolute",
                  right: "5px",
                  top: "-25px",
                  cursor: "pointer",
                }}
                onClick={() => deletePicture(img)}
              />
            </div>
          ))}
        </div>
        <div className="property-btn">
          <Btn
            btnClass={"home-btn"}
            btnText={`Edit Property`}
            btnClick={addProp}
            loading={isLoading}
          />
        </div>
      </div>}
    </>
  );
};

export default EditProperty;
